import { useSelector } from 'react-redux';
import { selectSideMenuWidth } from 'src/app/selectors/appDataSelectors';

import { DataGrid } from '@mui/x-data-grid';

export default function BasicTable({
  data,
  config,
  graphMultiDataKeys,
}: {
  data: any[];
  config: any;
  graphMultiDataKeys: string[];
}) {
  const isbar = config.graphType === 'bar';
  let updatedData = data;
  if (isbar) {
    updatedData = updatedData
      .filter((item) => item.value > 0 && item.value)
      .sort((a, b) => b.value - a.value);
  }

  const sideMenuWidth = useSelector(selectSideMenuWidth);
  const columns = [
    { field: config.header, headerName: config.header, width: 150 },
    ...updatedData.map((item) => ({
      field: item.x.toString(),
      headerName: config.value(item.x),
      width: 100,
    })),
  ];

  // Create rows with y values
  let rows = [
    {
      id: 'values',
      [config.header]: 'Value',
      ...updatedData.reduce(
        (acc, item) => ({ ...acc, [item.x]: item.y | item.value }),
        {},
      ),
    },
  ];
  if (graphMultiDataKeys.length > 0) {
    rows = [];
    graphMultiDataKeys.map((itemKey, index) =>
      rows.push({
        id: 'values',
        [config.header]: itemKey,
        ...updatedData.reduce(
          (acc, item) => ({ ...acc, [item.x]: item[itemKey] }),
          {},
        ),
      }),
    );
  }

  return (
    <div
      style={{ width: `calc(100vw - ${sideMenuWidth}px)`, overflowX: 'auto' }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight
        hideFooter={true}
        disableColumnMenu={true}
      />
    </div>
  );
}
